<script>
import CrudList from 'Arch/components/crud/CrudList.vue';
import CategoriesRequest from 'Modules/contacard/faq/categories/CategoriesRequest';

export default {
  name: 'CategoriesCrudList',
  extends: CrudList,
  data: () => ({
    requestClass: CategoriesRequest,
    editRoute: 'contacard.faq.categories.edit',
    headers: [
      {
        text: 'Nome da categoria',
        value: 'name',
      },
      {
        text: 'Descrição',
        value: 'description',
      },
    ],
  }),
};
</script>
